module.exports = __webpack_public_path__ + "static/media/img_maratona.8e70880f.jpg";